/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
    <LoadScreen v-if="mostrarLoader"></LoadScreen>
    <ModalExito v-if="mostrarExito" :mostrarExito="mostrarExito"></ModalExito>
    <ModalError v-if="mostrarError" :mostrarError="mostrarError"></ModalError>

    <ModalBase v-if="mostrarModal">
        <section class="contenedorPrincipal">
            <section>
                <div class="titulo">{{ tituloHeader }}</div>
                <div class="separador"></div>
            </section>

            <div class="form-group">
                <div class="label">Nombre del Proveedor:</div>
                <input class="inputEditar" type="text" maxlength="20" v-model="nombreFerreteria"
                    placeholder="Ingrese el nombre del proveedor" />
            </div>

            <div class="form-group">
                <div class="label">Selecciona un estado:</div>
                <div>
                    <select class="inputEditar" id="estado" name="estado" required v-model="estadoSeleccionado"
                        @change="llenarCiudades">
                        <option value="">-- Seleccione un estado --</option>
                        <option v-for="estado in estadosDisponibles" :key="estado.nombre" :value="estado.nombre">
                            {{ estado.nombre }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group">
                <div class="label">Selecciona una ciudad:</div>
                <div>
                    <select class="inputEditar" id="ciudad" name="ciudad" required v-model="ciudadSeleccionada"
                        :disabled="!ciudadesDisponibles.length">
                        <option value="">-- Primero selecciona un estado --</option>
                        <option v-for="ciudad in ciudadesDisponibles" :key="ciudad" :value="ciudad">
                            {{ ciudad }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group">
                <div class="label">Domicilio:</div>
                <input class="inputEditar" type="text" maxlength="50" v-model="domicilio"
                    placeholder="Ingrese el domicilio del proveedor" />
            </div>

            <div class="form-group">
                <div class="label">Correo electrónico:</div>
                <input class="inputEditar" type="email" maxlength="40" v-model="correo"
                    placeholder="Ingrese un correo electrónico" />
            </div>

            <div class="form-group">
                <div class="label">Teléfono:</div>
                <input class="inputEditar" type="numeric" maxlength="10" v-model="telefono"
                    placeholder="Ingrese un teléfono de contacto" />
            </div>
            <div class="form-group">
            <div class="label">Tipo de proveedor:</div>
            <div>
                <select class="inputEditar" id="tipoProveedor" v-model="tipoSeleccionado">
                    <option value="" disabled>-- Seleccione un tipo --</option>
                    <option value="Electrico">Electrico</option>
                    <option value="Ferreteria">Ferreteria</option>
                    <option value="Fotovolcaico">Fotovoltaico</option>
                </select>
            </div>
        </div>

            <section class="contenedorBotones">
                <Button class="btn-regresar" @click="cancelar">Regresar</Button>
                <Button class="btn-guardar" @click="registrarProveedor">Guardar</Button>
            </section>
        </section>
    </ModalBase>
</template>

<script>
import Button from "../Forms/Button.vue";
import ModalBase from "../Modales/ModalBase.vue";
import ModalExito from "../Modales/ModalExito.vue";
import ModalError from "../Modales/ModalError.vue";
import LoadScreen from '../Forms/LoadScreen.vue';
import providerService from "@/services/providerService.js";


// 1. IMPORTAR EL JSON (Propiedad de Connect & Launch)
import estadosData from '../../data/estados_municipios.json';

export default {
    components: {
        Button,
        ModalBase,
        ModalExito,
        ModalError,
        LoadScreen,
    },
    props: {
        tituloHeader: {
            type: String,
            default: "Agregar Proveedor",
        },
        tipoInicial: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            estadosDisponibles: estadosData.estados,

            estadoSeleccionado: '',
            ciudadSeleccionada: '',
            ciudadesDisponibles: [],

            mostrarLoader: false,
            mostrarModal: true,
            mostrarExito: false,
            mostrarError: false,
            nombreFerreteria: '',
            nombre: '', 
            Domicilio:'',
            correo: '',
            telefono: '',
            tipoSeleccionado:'',

            apellidoPaterno: '',
            apellidoMaterno: '',
            clave: '',
            rol: '',
        };
    },
    emits: ["cancelar"],
    methods: {
        llenarCiudades() {
            this.ciudadSeleccionada = '';

            const nombreEstado = this.estadoSeleccionado;

            const estadoEncontrado = this.estadosDisponibles.find(
                estado => estado.nombre === nombreEstado
            );

            if (estadoEncontrado) {
                this.ciudadesDisponibles = estadoEncontrado.municipios.map(m=>m.nombre);
            } else {
                this.ciudadesDisponibles = [];
            }
        },

        cancelar() {
            this.$emit("cancelar");
        },

        resetForm() {
            this.nombreFerreteria = '';
            this.domicilio = '';
            this.apellidoPaterno = '';
            this.apellidoMaterno = '';
            this.correo = '';
            this.clave = '';
            this.telefono = '';
            this.estadoSeleccionado = '';
            this.ciudadSeleccionada = '';
            this.ciudadesDisponibles = [];
            this.tipoSeleccionado = '';
        },

        async registrarProveedor() {
            this.mostrarModal = false;

            if (!this.nombreFerreteria || !this.estadoSeleccionado || !this.ciudadSeleccionada || !this.domicilio || !this.correo || !this.telefono || !this.tipoSeleccionado) {
                this.mostrarError = true;
                setTimeout(() => {
                    this.mostrarError = false;
                    this.mostrarModal = true;
                }, 2000);
                return;
            }

            this.mostrarLoader = true;

            const proveedorData = {
                Nombre: this.nombreFerreteria,
                Estado: this.estadoSeleccionado,
                Ciudad: this.ciudadSeleccionada,
                Domicilio: this.domicilio,
                Correo: this.correo,
                Telefono: this.telefono,
                Tipo:this.tipoSeleccionado,
            };
            try{
            const response = await providerService.createProvider(proveedorData);
            console.log("Proveedor registrado con éxito", response);
            this.mostrarLoader = false;
            this.mostrarExito = true;

            this.$emit("guardado");

            setTimeout(() => {
            this.mostrarExito = false;
            this.$emit("cancelar");
            }, 2000);  
            }catch(error){
                console.error("Error al registrar el proveedor:", error);
                this.mostrarLoader = false;
                this.mostrarError = true;
                setTimeout(() => (this.mostrarError = false), 2000);
            }      
        },
    },
    mounted() {
        this.ciudadesDisponibles = [];
    }
};
</script>

<style scoped>
.contenedorPrincipal {
    margin: 0px 30px;
    padding-bottom: 20px;
}

.titulo {
    padding: 30px 0px 10px 0px;
    font-size: 28px;
    font-weight: 600;
    color: #333;
    word-wrap: break-word;
    margin: 0px 20px;
}

.separador {
    border-top: 3px solid #2a428c;
    height: 2px;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 25px;
    opacity: 0.9;
}

.form-group {
    margin-bottom: 15px;
}

.label {
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 14px;
    color: #444;
}

.inputEditar {
    width: 100%;
    max-width: 350px;
    height: 38px;
    background-color: #fff;
    border: 1px solid #cbd5e1;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 0px 10px;
    font-size: 14px;
    color: #333;
    outline: none;
    box-sizing: border-box;
    transition: all 0.3s ease;
}

.inputEditar:focus {
    outline: none;
    border-color: #29b9f6;
    box-shadow: 0 0 0 3px rgba(47, 141, 183, 0.2);
}

.contenedorBotones {
    display: flex;
    justify-content: space-around;
    gap: 20px;
    margin-top: 35px;
    width: 100%;
}

@media (max-width: 768px) {
    .contenedorPrincipal {
        margin: 0px 15px;
    }

    .titulo {
        font-size: 22px;
        padding-top: 20px;
        text-align: left;
        margin: 0px;
    }

    .separador {
        margin-bottom: 20px;
    }

    .label {
        font-size: 15px;
        margin-top: 10px;
    }

    .inputEditar {
        max-width: 100%;
        height: 42px;
        font-size: 16px;
        padding: 0px 12px;
    }

    .contenedorBotones {
        margin-top: 25px;
        gap: 15px;
    }
}
</style>